import { render, staticRenderFns } from "./DataSettings.vue?vue&type=template&id=ce2e019c&scoped=true"
import script from "./DataSettings.vue?vue&type=script&lang=js"
export * from "./DataSettings.vue?vue&type=script&lang=js"
import style0 from "./DataSettings.vue?vue&type=style&index=0&id=ce2e019c&prod&lang=css"
import style1 from "./DataSettings.vue?vue&type=style&index=1&id=ce2e019c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2e019c",
  null
  
)

export default component.exports